import React from 'react';

export default function FilterBar({ filters, onChange }) {
  const handleChange = (key, value) => {
    onChange({ ...filters, [key]: value });
  };

  return (
    <div className="filter-bar">
      <div className="filter-group">
        <label className="filter-label">Search Code</label>
        <input
          type="text"
          className="input"
          placeholder="Enter code..."
          value={filters.search}
          onChange={(e) => handleChange('search', e.target.value)}
        />
      </div>

      <div className="filter-group">
        <label className="filter-label">Status</label>
        <select
          className="select"
          value={filters.status}
          onChange={(e) => handleChange('status', e.target.value)}
        >
          <option value="all">All</option>
          <option value="paid">Paid</option>
          <option value="unpaid">Unpaid</option>
          <option value="used">Used</option>
          <option value="available">Available</option>
        </select>
      </div>

      <div className="filter-group">
        <label className="filter-label">Date Range</label>
        <select
          className="select"
          value={filters.dateRange}
          onChange={(e) => handleChange('dateRange', e.target.value)}
        >
          <option value="all">All Time</option>
          <option value="today">Today</option>
          <option value="week">This Week</option>
          <option value="month">This Month</option>
          <option value="year">This Year</option>
        </select>
      </div>

      {(filters.search || filters.status !== 'all' || filters.dateRange !== 'all') && (
        <button
          className="btn btn-secondary"
          onClick={() => onChange({ search: '', status: 'all', dateRange: 'all' })}
        >
          Clear Filters
        </button>
      )}
    </div>
  );
}
